import { createInjectionKey as n } from "./highrise529.mjs";
const t = n("n-form"), e = n("n-form-item-insts");
export {
  t as formInjectionKey,
  e as formItemInstsInjectionKey
};
